import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Flex, Heading, Link, Button, Text } from '@pancakeswap/uikit'
import useActiveWeb3React from 'contexts/Web3Context'
import { useTranslation } from 'contexts/Localization'
import ConnectWalletButton from 'components/ConnectWalletButton'
import useTheme from 'hooks/useTheme'
import { CustomButton } from './CustomButton'

const BunnyWrapper = styled.div`
  width: 100%;
  text-align: right;

  img {
    display: none;
    
    ${({ theme }) => theme.mediaQueries.xs} {
      max-width: 160px;
    }

    ${({ theme }) => theme.mediaQueries.sm} {
      display: block;
      max-width: 240px;  
    }

    ${({ theme }) => theme.mediaQueries.md} {
      max-width: 313px;  
    }
  }
`

const Hero = () => {
  const { t } = useTranslation()
  const { account } = useActiveWeb3React()
  const { theme } = useTheme()

  return (
    <>
      <Flex
        position="relative"
        flexDirection={['row', null, null, 'row']}
        alignItems={['flex-end', null, null, 'center']}
        justifyContent="center"
      >
        <Flex flex="1" flexDirection="column">
          <Heading scale="xl" color="input" mb="8px">
            {t('Home')}
          </Heading>
          <Text mb="24px" color="input" fontSize="21px">
            {t('BirbSwap is only part of the ecosystem.')}
          </Text>
          <Flex>
            <Link mr="16px" href="https://pancakeswap.finance/swap?outputCurrency=0x2e8799f0A26d8A9f37a0b4747Fa534f039C2d234" target='_blank'>
              <CustomButton variant='primary'>{t('Trade')}</CustomButton>
            </Link>
          </Flex>
        </Flex>
        <Flex
          height='fit-content'
          width='fit-content'
          flex={[null, null, null, null]}
          mb={['24px', null, null, '0']}
          position="relative"
        >
          <BunnyWrapper>
            <img src="/images/custom/home-1.png" alt={t('Home 1st section')} />
          </BunnyWrapper>
        </Flex>
      </Flex>
    </>
  )
}

export default Hero
